import React from 'react';
import { useLanguage } from '@/app/contexts/LanguageContext';
import { Monitor, Smartphone, ArrowRight } from 'lucide-react';
import { Button } from '@/app/components/ui/button';

interface MobileRestrictionMessageProps {
  onShowLandingPage: () => void;
}

export function MobileRestrictionMessage({ onShowLandingPage }: MobileRestrictionMessageProps) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center space-y-6 animate-in fade-in duration-500">
      <div className="relative">
        <Monitor className="w-24 h-24 text-muted-foreground opacity-20" />
        <Smartphone className="w-12 h-12 text-primary absolute -bottom-2 -right-2" />
      </div>
      
      <div className="space-y-2 max-w-sm">
        <h2 className="text-2xl font-bold tracking-tight">
          {t.app.mobileRestriction.title}
        </h2>
        <p className="text-muted-foreground">
          {t.app.mobileRestriction.message}
        </p>
      </div>

      <Button onClick={onShowLandingPage} size="lg" className="mt-4">
        {t.app.mobileRestriction.backToLanding}
        <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
